export default "__VITE_ASSET__DXqi4vga__"